export const stringOrUndefined = (str) =>
  typeof str === 'string' ? str : undefined
